$(document).ready(function () {
    'use strict';

    // Compare Cars

    const comparedCarsCount =  $(".comparedCarsTitle span");
    const noResults = $(".comparedCarsWrapper .noResults");
    const comparedCarsContainer = $("#comparedCars");

    function getComparedCars(cars) {
        const loading = $(".comparedCarsWrapper #loadingOverlay");

        loading.fadeIn();

        $.ajax({
            type: 'get',
            url: '/sites/petervardy/templates/ajax/get-compared-cars.php?ajax=true&comparedCars=' + cars,
            success: function (response) {
                const result = JSON.parse(response);
                const count = result.count;

                if (count > 0) {
                    noResults.hide()
                }

                comparedCarsContainer.html(result.body);
                comparedCarsCount.text(count);

                setTimeout(() => {
                    $('.compareImgHeight').matchHeight();
                }, 300);

                $('.info .smallDescription').matchHeight();

                storefrontPopup();

                loading.fadeOut();
            }
        });
    }

    const comparedCars = JSON.parse(localStorage.getItem('comparedCars'));
    let carsArray = [];

    if (comparedCars) {
        carsArray = comparedCars;
    }

    if (comparedCarsContainer.length > 0 && carsArray) {
        getComparedCars(carsArray);
    }
});
